import { Empty } from "@/components/Empty";
import { Icon } from "@/components/Icon";
import { Grid, List } from "antd-mobile";
import classNames from "classnames";
import styles from "./index.module.scss";
export type ListTableColumn = {
  title: string | React.ReactNode;
  dataIndex: string;
  span: number | undefined;
  render?: (text: any, row: any, restData?: any) => React.ReactNode;
};
export type ListTableProps<T = any> = {
  columns: ListTableColumn[];
  data: T[];
  restData?: any;
  total: number;
  onMoreClick: () => void;
  onRowClick: (row: T) => void;
};

export default function ListTable(props: ListTableProps) {
  return (
    <>
      <List className={classNames(styles.listTable, styles.listTableHeader)}>
        <div className={styles.listTableHeaderItem}>
          <Grid columns={24} gap={0}>
            {props.columns.map((col) => (
              <Grid.Item span={col.span || 24} key={col.dataIndex}>
                {col.title}
              </Grid.Item>
            ))}
          </Grid>
        </div>
      </List>
      <List className={styles.listTable}>
        {props.data.length ? (
          props.data.map((row, index) => {
            return (
              <div
                key={`${row.id}_${index}`}
                onClick={() => props.onRowClick(row)}
                className={styles.list_row}
              >
                <Grid columns={24} gap={0}>
                  {props.columns.map((col) => (
                    <Grid.Item
                      span={col.span || 24}
                      key={`${row.id}_${col.dataIndex}`}
                    >
                      {typeof col.render === "function"
                        ? col.render(row[col.dataIndex], row, props.restData)
                        : row[col.dataIndex] || "-"}
                    </Grid.Item>
                  ))}
                </Grid>
              </div>
            );
          })
        ) : (
          <Empty />
        )}
      </List>
      {props.total && props.total > 5 ? (
        <div className={styles.more} onClick={props.onMoreClick}>
          更多
          <Icon name={"operate_arrow_right"} size={"20px"} />
        </div>
      ) : null}
    </>
  );
}
